import { Injectable } from '@angular/core';
import { SearchModel } from '@core/models';
import { ApiService } from '@core/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  constructor(private readonly apiService: ApiService) {}

  getSearchs(text: string): Observable<SearchModel> {
    return this.apiService.get<SearchModel>('/generic/search', { searchTerm: text } as any);
  }
}
